import { Badge, ComponentStyleConfig, defineStyle } from "@chakra-ui/react";
import { GenericTableBadgeColorEnum } from "gen/model/genericTableBadgeColorEnum";
import { textStyles } from "theme/textStyles";

const bgs: Record<GenericTableBadgeColorEnum, string> = {
  blue: "var(--chakra-colors-blue-50)",
  category_adjustment: "var(--chakra-colors-warning-50)",
  category_capital_call: "var(--chakra-colors-blue-50)",
  category_close: "var(--chakra-colors-indigo-50)",
  category_distribution: "var(--chakra-colors-teal-50)",
  category_end_of_quarter_report: "var(--chakra-colors-cyan-25)",
  category_equalization: "var(--chakra-colors-cyan-25)",
  category_management_fee: "var(--chakra-colors-eggplant-100)",
  category_net_event: "var(--chakra-colors-purple-50)",
  category_transfer_in: "var(--chakra-colors-indigo-50)",
  category_transfer_out: "var(--chakra-colors-gray-200)",
  cyan: "var(--chakra-colors-cyan-25)",
  dark_gray: "var(--chakra-colors-gray-200)",
  default: "var(--chakra-colors-gray-100)",
  eggplant: "var(--chakra-colors-eggplant-100)",
  error: "var(--chakra-colors-error-50)",
  indigo: "var(--chakra-colors-indigo-50)",
  pink: "var(--chakra-colors-pink-100)",
  primary: "var(--chakra-colors-primary-25)",
  purple: "var(--chakra-colors-purple-50)",
  success: "var(--chakra-colors-primary-100)",
  teal: "var(--chakra-colors-teal-50)",
  warning: "var(--chakra-colors-warning-50)",
};

const colors: Record<GenericTableBadgeColorEnum, string> = {
  blue: "var(--chakra-colors-blue-700)",
  category_adjustment: "var(--chakra-colors-warning-700)",
  category_capital_call: "var(--chakra-colors-blue-700)",
  category_close: "var(--chakra-colors-indigo-700)",
  category_distribution: "var(--chakra-colors-teal-700)",
  category_end_of_quarter_report: "var(--chakra-colors-cyan-700)",
  category_equalization: "var(--chakra-colors-cyan-700)",
  category_management_fee: "var(--chakra-colors-eggplant-800)",
  category_net_event: "var(--chakra-colors-purple-700)",
  category_transfer_in: "var(--chakra-colors-indigo-700)",
  category_transfer_out: "var(--chakra-colors-gray-900)",
  cyan: "var(--chakra-colors-cyan-700)",
  dark_gray: "var(--chakra-colors-gray-900)",
  default: "var(--chakra-colors-gray-700)",
  eggplant: "var(--chakra-colors-eggplant-800)",
  error: "var(--chakra-colors-error-700)",
  indigo: "var(--chakra-colors-indigo-700)",
  pink: "var(--chakra-colors-pink-800)",
  primary: "var(--chakra-colors-primary-700)",
  purple: "var(--chakra-colors-purple-700)",
  success: "var(--chakra-colors-primary-700)",
  teal: "var(--chakra-colors-teal-700)",
  warning: "var(--chakra-colors-warning-700)",
};

const BadgeTheme: ComponentStyleConfig = {
  baseStyle: defineStyle(({ colorScheme }) => ({
    "&&": {
      "--badge-bg": bgs[colorScheme as GenericTableBadgeColorEnum],
      "--badge-color": colors[colorScheme as GenericTableBadgeColorEnum],
      textStyle: colorScheme.startsWith("category_") ? "small" : "smallBold",
      lineHeight: "18px",
    },
    borderRadius: colorScheme.startsWith("category_") ? 4 : 16,
    textTransform: "unset",
    py: "2px",
    px: "8px",
    width: "max-content",
    "& .chakra-icon": {
      ml: "4px",
    },
  })),
  variants: {
    button: {
      cursor: "pointer",
      userSelect: "none",
      _active: {
        filter: "brightness(0.95)",
      },
    },
    category: {
      borderRadius: "4px",
      "&&": {
        fontWeight: "normal",
      },
    },
    beta: {
      borderRadius: "2px",
      px: "2px",
      py: "1px",
      background: "var(--chakra-colors-teal-700)",
      "&&": {
        fontSize: "8px",
        fontWeight: 500,
        textColor: "white",
        lineHeight: "10px",
      },
    },
    xl: {
      px: "12px",
      py: "4px",
      borderRadius: "16px",
      "&&": {
        fontSize: textStyles.h5.fontSize,
        lineHeight: textStyles.h5.lineHeight,
        fontWeight: textStyles.h5.fontWeight,
      },
    },
  },
};

Badge.defaultProps = {
  colorScheme: "default",
};

export default BadgeTheme;
